export const getCauseOptions = (t) => [
	{ value: 'disease', label: t('admin.animal.cause_disease') },
	{ value: 'accident', label: t('admin.animal.cause_accident') },
	{ value: 'birthProcess', label: t('admin.animal.cause_birthProcess') },
	{ value: 'disease_serious', label: t('admin.animal.cause_disease_serious') },
	{ value: 'unrecoverable_injury', label: t('admin.animal.cause_unrecoverable_injury') },
	{ value: 'unknown', label: t('admin.animal.cause_unknown') },
	{ value: 'other', label: t('admin.animal.cause_other') }
]